import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ITicketsState {
  issueTypeAddDialog: boolean; // 问题类型 新建/编辑 弹框
  computerAddDialog: boolean; // 笔记本型号 新建/编辑 弹框
  teamInfoAddDialog: boolean;// 团队信息  新建/编辑  弹窗'
  workdayAddDialog: boolean;// 团队信息  新建/编辑  弹窗
  areaAddDialog: boolean; // 地区 新建/编辑 弹框
  buildAddDialog: boolean; // 基地 新建/编辑 弹框
  groupAddDialog: boolean; // 群组 新建/编辑 弹框
  configLogDialog: boolean; // 配置操作日志弹框
  globalConfigDialog: boolean; // 基础操作 弹窗
  commonTypeAddDialog: boolean; // 地区 新建/编辑 弹框
  strategyAddDialog: boolean; // 基地解决方案 新建/编辑 弹框
}

// eslint-disable-next-line @typescript-eslint/class-name-casing
interface dialogShowStatus {
  name: any;
  value: boolean;
}

@Module({ dynamic: true, store, name: 'config' })
class Config extends VuexModule implements ITicketsState {
  public issueTypeAddDialog = false
  public computerAddDialog = false
  public teamInfoAddDialog = false
  public workdayAddDialog = false
  public areaAddDialog = false
  public buildAddDialog = false
  public groupAddDialog = false
  public configLogDialog = false
  public globalConfigDialog = false
  public commonTypeAddDialog=false
  public strategyAddDialog = false
  public issueTypeOptions = [] // 问题类型选项
  public computerTypeOptions = [] // 笔记本型号选项
  public globalConfigOptions = [] // 全局配置选项
  public commonTypeOptions = [] // 问题类型选项
  public strategyOptions = [] // 问题类型选项

  @Mutation
  private TOGGLE_DIALOG(obj: dialogShowStatus) {
    (this as any)[obj.name] = obj.value
  }

  @Action
  public ToggleDialogStatus(obj: dialogShowStatus) {
    this.TOGGLE_DIALOG(obj)
  }

  // 设置问题类型options
  @Action
  public setIssueTypeOptions(value: any) {
    this.TOGGLE_DIALOG({
      name: 'issueTypeOptions',
      value
    })
  }

  // 设置通用配置类型options
  @Action
  public setCommonTypeOptions(value: any) {
    this.TOGGLE_DIALOG({
      name: 'commonTypeOptions',
      value
    })
  }

  // 设置笔记本型号options
  @Action
  public setComputerTypeOptions(value: any) {
    this.TOGGLE_DIALOG({
      name: 'computerTypeOptions',
      value
    })
  }
  @Action
  public setStrategyOptions(value: any) {
    this.TOGGLE_DIALOG({
      name: 'strategyOptions',
      value
    })
  }
  // 设置配置类型options
  @Action
  public setGlobalConfigOptions(value: any) {
    this.TOGGLE_DIALOG({
      name: 'globalConfigOptions',
      value
    })
  }
}

export const ConfigModule = getModule(Config)
